import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ControlService {
  players: string[] = [];
  failedCounter: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  constructor() {
    this.failedCounter.next(0);
  }
}
